import {
  Arrange,
  Button,
  FormField,
  Link,
  Spacer,
  Text,
  TextInput,
} from '@loomhq/lens';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorBar } from 'actions/errorBar';
import { ERROR, SUCCESS } from 'constants/error-severities';
import { getUserCreator } from 'creators/user';
import { selectCurrentUser } from 'selectors/user';
import { getGraphQLClient } from 'utilities/graphql';
import * as sentry from 'utilities/sentry';
import { getParam } from 'utilities/url';

import sendEmailVerification from './sendEmailVerification.graphql';

import ErrorBar from 'components/error-bar';
import NavigationBar from 'components/navigation-bar';
import styles from 'components/signup/styles.module.less';

const VerifyEmail = ({ modalMode, email }) => {
  const currentUser = useSelector(selectCurrentUser);

  const [isSending, setIsSending] = useState(false);

  const emailAddress =
    email || currentUser?.email || decodeURIComponent(getParam('email')) || '';

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserCreator());
  }, [dispatch]);

  const sendVerificationEmail = async () => {
    const client = getGraphQLClient();

    try {
      setIsSending(true);

      const { data } = await client.mutate({
        mutation: sendEmailVerification,
        variables: {
          email: emailAddress,
        },
      });

      // Because now this is open, we don't want users to
      // be hammering emails to everyone, so we don't reenable the button
      if (data.sendEmailVerificationEmail) {
        dispatch(showErrorBar(SUCCESS, 'Verification email sent!'));
      }
    } catch (err) {
      dispatch(
        showErrorBar(ERROR, 'An error occurred sending verification email')
      );
      sentry.logException(err, 'error sending verification email');

      setIsSending(false);
    }
  };

  const verifyEmailContent = (
    <Arrange autoFlow="row" gap="large">
      <Text
        alignment="left"
        htmlTag="h1"
        size={modalMode ? 'xlarge' : 'xxlarge'}
        fontWeight="bold"
      >
        Verify your email
      </Text>
      <Text>
        We sent a verification link to the email you provided. Click the link to
        verify your email. You may need to check your spam folder.
      </Text>
      <Arrange autoFlow="row" gap="small" justifyContent="stretch">
        <FormField label="Email address" labelFor="email">
          <TextInput
            isDisabled={true}
            id="email"
            type="email"
            value={emailAddress}
          />
        </FormField>
        <Button
          hasFullWidth
          variant="primary"
          onClick={sendVerificationEmail}
          isDisabled={isSending}
          id="resendVerificationEmailButton"
        >
          Don’t see it? Resend
        </Button>
      </Arrange>
      {currentUser.email && (
        <Text>
          Not your account? <Link href="/logout">Sign Out</Link>
        </Text>
      )}
    </Arrange>
  );

  return (
    <>
      <ErrorBar />
      {modalMode ? (
        <>{verifyEmailContent}</>
      ) : (
        <>
          <NavigationBar variant="empty" />
          <Spacer top="large" />
          <div className={styles.loomSignupComponentWrap}>
            <div
              className={classNames(
                styles.loomSignupComponent,
                'flex flexDirection:column items:center'
              )}
            >
              {verifyEmailContent}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default VerifyEmail;
